module.exports = __webpack_public_path__ + "img/111.3.5ca8cba5.png";